module.exports = __webpack_public_path__ + "static/media/Pizza Box Solar Oven Directions.abd982ed.pdf";